import { RestClient } from "@elite/restclient";

export const restClient = new RestClient();
restClient.client.defaults.baseURL = process.env.VUE_APP_API_BASE_URI || "";
